/** Sell amount within 1% of current value — used for isFullWithdrawal on sell CTAs. */
export function isPlanFullSell(sellAmount: number, currentValue: number): boolean {
  return currentValue > 0 && Math.abs(sellAmount - currentValue) <= currentValue * 0.01
}
